import { useMutation, gql } from '@apollo/client';
import {
  EditarProjetoMutation,
  EditarProjetoMutationVariables,
} from './__generated__/EditarProjetoMutation';

const EDITAR_PROJETO_MUTATION = gql`
  mutation EditarProjetoMutation(
    $id_projeto_pedagogico: Int!
    $id_oferta: Int
    $id_professor: Int
    $id_disciplina: Int
    $ind_semestre: Int
    $ind_ordem: Int
    $num_carga_horaria_to: Int
    $dsc_modalidade: String
    $ind_modalidade: Int
    $dsc_sigla_disciplina: String
  ) {
    editarProjetoPedagogico(
      input: {
        id_projeto_pedagogico: $id_projeto_pedagogico
        id_oferta: $id_oferta
        id_professor: $id_professor
        id_disciplina: $id_disciplina
        ind_semestre: $ind_semestre
        ind_ordem: $ind_ordem
        num_carga_horaria_to: $num_carga_horaria_to
        dsc_modalidade: $dsc_modalidade
        ind_modalidade: $ind_modalidade
        dsc_sigla_disciplina: $dsc_sigla_disciplina
      }
    ) {
      id_projeto_pedagogico
      id_oferta
      id_disciplina
      id_professor
      ind_semestre
      ind_ordem
      num_carga_horaria_to
      dsc_modalidade
      ind_modalidade
      dsc_sigla_disciplina
      disciplina {
        id_disciplina
        dsc_nome_disciplina
        dsc_sigla
        num_carga_horaria
      }
      professor {
        id_professor
        dsc_nome_professor
      }
      oferta {
        id_oferta
        id_curso
        num_oferta
        num_ano
        num_semestre
      }
    }
  }
`;

const useEditarProjetoMutation = () => {
  return useMutation<EditarProjetoMutation, EditarProjetoMutationVariables>(
    EDITAR_PROJETO_MUTATION
  );
};

export { useEditarProjetoMutation };
